import { InternalBet } from '@cgs/data-access';
import { BaseStore } from '@cgs/shared';

export const BET_STORE_TOKEN = Symbol('BET_STORE_TOKEN');

interface IBetStore {
  bet: number;
  lines: number;
  bets: InternalBet[];
  defaultBet: number;
}

const DEFAULT_STATE: IBetStore = {
  bet: 0,
  lines: 0,
  bets: [],
  defaultBet: 0,
};

export class BetStore extends BaseStore<IBetStore> {
  constructor(params?: Partial<IBetStore>) {
    super({ ...DEFAULT_STATE, ...params });
  }
}
